import React from 'react';

import StatusPanel from '../StatusPanel';

interface IProjectExportProps {
  visible: boolean;
  loading?: boolean;
  onClose?: () => void;
}

const ProjectExport: React.FC<IProjectExportProps> = ({ visible, loading, onClose }) => {
  return <StatusPanel.LoadingPanel group="Project: Export" loading={loading} visible={visible} onClose={onClose} />;
};

export default ProjectExport;
